import { useEffect, useMemo, useState } from 'react';
import { Row, Col, Container, } from "react-bootstrap";
import { BzTabsContent, BzTabsContainer, BzChip, BzCard } from "../../components";
import { useSelector, useDispatch } from 'react-redux';
import { getGSMGradeCategory, GetContractDetails, getCommonCompanyContractData } from '../../redux/actions/marketOverview';
import { MULTIPLIER, WATCHLIST_GRID_INDEX, MARKET_SEGMENT_ID, SCRIP_INSTRUMENTS } from '../../utils/global_variables';
import { convertToDate, convertDateToSeconds, checkNonBlankNonZero, nullCheck } from '../../utils/global_functions';


const ContractDetails = () => {
    //Vaibhav Singh: 14-12-23: BT-107428: updated 'NA' and updated spelling mistake : Start
    const dispatch = useDispatch();
    const scripOverviewData = useSelector(state => state?.marketOverview.scripOverviewData);
    const objContractDetails = useSelector(state => state?.marketOverview?.objContractDetails);
    const recordData = useSelector(state => state?.marketOverview?.recordData);
    const listing = useSelector(state => state.marketOverview.listing);
    const objContractCodeInfo = useSelector(state => state.marketOverview.objContractCodeInfo);
    const objContractMarginDetails = useSelector(state => state?.marketOverview?.objContractMarginDetails);
    const arrExchangeData = useSelector(state => state?.marketOverview?.arrExchangeData);
    const arrDirectorData = useSelector(state => state?.marketOverview?.arrDirectorData);
    const objCompanyBackgroundData = useSelector(state => state.marketOverview.objCompanyBackgroundData);
    const objCompanyHistory = useSelector(state => state?.marketOverview?.objCompanyHistory);
    const availableExchanges = useSelector(state => state?.marketOverview.availableExchanges);
    const [companyActiveChip, setCompanyActiveChip] = useState("register_adress");
    const [showMore, setShowMore] = useState(true);
    const companyListed = nullCheck(arrExchangeData?.length > 0 ? arrExchangeData?.map((item) => item?.Sector_Names)?.join(', ') : null);
    // Vaibhav Singh: 30-01-24: BT-107248: Causing error due to validation Change: Start
    const register = Object.keys(objCompanyBackgroundData)?.length ? objCompanyBackgroundData?.regAddress1 !== undefined ? objCompanyBackgroundData?.regAddress1 + ',' + objCompanyBackgroundData?.regAddress2 + ',' + objCompanyBackgroundData?.regCity + ',' + objCompanyBackgroundData?.regPin : null : 'NA';
    const registrar = Object.keys(objCompanyBackgroundData)?.length ? objCompanyBackgroundData?.address1 + ',' + objCompanyBackgroundData?.address2 + ',' + objCompanyBackgroundData?.address3 + ',' + objCompanyBackgroundData?.address4 : 'NA';
    const headOffice = objCompanyBackgroundData?.hoa1 + ',' + objCompanyBackgroundData?.hoa2 + ',' + objCompanyBackgroundData?.hoa3 + ',' + objCompanyBackgroundData?.hoc + ',' + objCompanyBackgroundData?.hop + ',' + objCompanyBackgroundData?.hot;
    const headOfficeAddr = Object.keys(objCompanyBackgroundData)?.length ? (headOffice !== '-,-,-,-,-,-') ? headOffice : 'NA' : 'NA';

    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const token = arrScripExchanges?.length > 0 ? arrScripExchanges[0][WATCHLIST_GRID_INDEX.TOKEN] : '';

    // Vaibhav Singh: 30-01-24: BT-107248: Causing error due to validation Change: End
    //Vaibhav Singh : BT-107248: 04-12-23: Added UseState for toggle: start
    const [showInfo, setShowInfo] = useState(null);
    //Vaibhav Singh : BT-107248: 04-12-23: Added UseState for toggle: End
    const toggleReadMore = () => {
        setShowMore(!showMore);
    };
    //Vaibav Singh: 08-12-23: BT-107248: Fixing 'NA' in contract details: Start

    // Vinit R - 03-04-2024 Company Info to be kept common irrespective of exchanges -- Start
    useEffect(() => {
        if (scripOverviewData?.length > 0) {
            // Vaibhav Singh: 30-01-24: BT-107248: Params updated: Start
            dispatch(GetContractDetails({ mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], expDate: convertDateToSeconds(scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE]), symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL], instName: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT], strkPrice: (scripOverviewData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) === '' ? '-1' : (parseFloat(scripOverviewData[WATCHLIST_GRID_INDEX?.STRIKEPRICE]) * scripOverviewData[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR]), optType: scripOverviewData[WATCHLIST_GRID_INDEX?.OPTIONTYPE] }));
            // Vaibhav Singh: 30-01-24: BT-107248: Params updated: End
        } else { }
    }, [scripOverviewData, dispatch]);

    useEffect(() => {
        if (scripOverviewData?.length > 0) {
            dispatch(getGSMGradeCategory({
                mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                nToken: scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN] : scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
            }));
        } else { }
    }, [scripOverviewData, dispatch]);

    // Vinit R - 18-04-2024 Company Info to be kept common irrespective of exchanges -- Start
    useEffect(() => {
        if (availableExchanges?.length > 0) {
            dispatch(getCommonCompanyContractData(availableExchanges));
        }
    }, [scripOverviewData, dispatch, availableExchanges]);
    // Vinit R - 18-04-2024 Company Info to be kept common irrespective of exchanges -- End

    let segId = scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID];
    let nPriceValue;
    if (objContractDetails?.nPrice !== undefined && objContractDetails.nPrice !== "") {
        nPriceValue = parseFloat(objContractDetails?.nPrice / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); // Prict Tick will be in Paise in Db... so convert to RS is required...
    }

    let nMaturity;
    if (segId === MARKET_SEGMENT_ID?.NSEL_DERIVATIVES || segId === MARKET_SEGMENT_ID?.NSEL_SPOT) {
        nMaturity = "";
    }
    else {
        if (objContractDetails?.nIssueMaturityDate !== undefined)
            nMaturity = convertToDate(objContractDetails?.nIssueMaturityDate, "DDMMMYYYY").toUpperCase();
    }

    let nExDate = nullCheck(objContractDetails?.nExpiryDate ? convertToDate(objContractDetails?.nExpiryDate, "DDMMMYYYY")?.toUpperCase() : null);

    let nPriceQuote;
    if (objContractDetails?.nPriceFactorQuota !== 0 && objContractDetails?.nPriceFactorQuota !== undefined) {
        nPriceQuote = objContractDetails?.nPriceFactorQuota + " " + objContractDetails?.sPriceQuotUnit;
    }
    else {
        nPriceQuote = nullCheck(objContractDetails?.sPriceQuotUnit);
    }

    let intMTI = nullCheck(objContractDetails?.nMarginTypeIndicator);
    let strMarginMul = objContractDetails?.nMarginMultiplier;
    let margin;
    if (objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.COMDTY) {
        intMTI = 2;
    }
    else if (intMTI === 1)
        margin = parseFloat(strMarginMul).toFixed(2) + "%";
    else if (intMTI === 2)
        margin = (parseFloat(strMarginMul) / MULTIPLIER.HUNDRED).toFixed(2);
    else
        margin = "NA";

    //exMultiplier
    let exMultiplierData;
    let dblIntVal;

    if (segId === MARKET_SEGMENT_ID?.NSE_DERIVATIVES ||
        segId === MARKET_SEGMENT_ID?.BSE_DERIVATIVES) {
        dblIntVal = objContractDetails?.nIntrinsicValue ? (parseFloat(objContractDetails?.nIntrinsicValue) / MULTIPLIER.TEN_THOUSAND) : 0;
        exMultiplierData = dblIntVal?.toFixed(2);
    }
    else {
        exMultiplierData = (objContractDetails?.nIntrinsicValue);
    }

    // Max order size
    let maxOrderSize = objContractDetails?.nMaxSingleTransactionQty;
    // if (segId == MARKET_SEGMENT_ID?.NSE_DERIVATIVES) {
    //     maxOrderSize = objContractDetails?.nMaxSingleTransactionQty;
    // }

    //IP date
    let nIPDate;
    if ((segId === MARKET_SEGMENT_ID?.NSEL_DERIVATIVES && objContractDetails?.InstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM)
        || (segId === MARKET_SEGMENT_ID?.NSEL_SPOT)
        || (segId === MARKET_SEGMENT_ID?.MSX_DERIVATIVES)
        || (segId === MARKET_SEGMENT_ID?.NMCE_DERIVATIVES)
        || (segId === MARKET_SEGMENT_ID?.MCX_DERIVATIVES && (objContractDetails?.InstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM && objContractDetails.InstrumentName !== SCRIP_INSTRUMENTS?.OPTFUT)))
        nIPDate = "NA";
    else if ((objContractDetails?.InstrumentName === SCRIP_INSTRUMENTS?.COMDTY))
        nIPDate = " ";
    else if ((segId === MARKET_SEGMENT_ID?.DGCX_DERIVATIVES) || (segId === MARKET_SEGMENT_ID?.BFX_DERIVATIVES) || (segId === MARKET_SEGMENT_ID?.UCX_DERIVATIVES)
        || (segId === MARKET_SEGMENT_ID?.DGCX_SPOT) || (segId === MARKET_SEGMENT_ID?.BFX_SPOT) || (segId === MARKET_SEGMENT_ID?.UCX_SPOT))
        nIPDate = 'NA';
    else {
        if ((objContractDetails.nIssuePDate)) {
            nIPDate = convertToDate(objContractDetails.nIssuePDate, "DDMMMYYYY").toUpperCase();

        }
        else {
            nIPDate = "NA";
        }
    }


    //ContractStartDate
    let ContractStartDate;

    if (objContractDetails?.nIssueStartDate && segId !== MARKET_SEGMENT_ID?.BSE_DERIVATIVES) {

        ContractStartDate = convertToDate((objContractDetails?.nIssueStartDate), "DDMMMYYYY HH:mm:ss").toUpperCase();
    }
    else {
        ContractStartDate = "NA";
    }

    // Contract End Date ...
    let ContractEndDate;

    if ((segId === MARKET_SEGMENT_ID?.NSEL_DERIVATIVES && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM)
        || (segId === MARKET_SEGMENT_ID?.NSEL_SPOT)
        || (segId === MARKET_SEGMENT_ID?.MCX_DERIVATIVES && (objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.OPTFUT))
        || (objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.COMDTY)) {
        ContractEndDate = "";
    }
    else if ((objContractDetails?.nIssueMaturityDate)) {
        ContractEndDate = convertToDate((objContractDetails?.nIssueMaturityDate), "DDMMMYYYY HH:mm:ss").toUpperCase();
    }
    else { ContractEndDate = "NA"; }

    //tenderStartDate
    let tenderStartDate;

    if (objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.COMDTY) {
        tenderStartDate = " ";
    }
    else if ((objContractDetails?.nExerciseStartDate) && segId !== MARKET_SEGMENT_ID?.BSE_DERIVATIVES) {
        tenderStartDate = convertToDate(objContractDetails?.nExerciseStartDate, "DDMMMYYYY").toUpperCase();
    }
    else { tenderStartDate = "NA"; }


    //tenderEndDate
    let tenderEndDate;
    if ((objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.COMDTY))
        tenderEndDate = "";
    else if ((objContractDetails?.nExerciseEndDate) && (segId !== MARKET_SEGMENT_ID?.BSE_DERIVATIVES && segId !== MARKET_SEGMENT_ID?.NSEL_SPOT)) {
        if ((segId === MARKET_SEGMENT_ID?.NSEL_DERIVATIVES && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM) || (segId === MARKET_SEGMENT_ID?.MCX_DERIVATIVES && (objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.OPTFUT)))
            tenderEndDate = 'NA';
        else
            tenderEndDate = convertToDate(objContractDetails?.nExerciseEndDate, "DDMMMYYYY").toUpperCase();
    }
    else
        tenderEndDate = "NA";

    //delStartDate
    let delStartDate;

    if ((objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS.COMDTY))
        delStartDate = " ";
    else if ((objContractDetails?.nNoDeliveryStartDate))
        delStartDate = convertToDate(objContractDetails?.nNoDeliveryStartDate, "DDMMMYYYY").toUpperCase();
    else
        delStartDate = "NA";

    //delEndDate
    let delEndDate;

    if ((objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.COMDTY))
        delEndDate = " ";
    else if ((objContractDetails?.nDelEndDate) && (segId !== MARKET_SEGMENT_ID?.BSE_DERIVATIVES && segId !== MARKET_SEGMENT_ID?.NSEL_SPOT))
        if ((segId === MARKET_SEGMENT_ID?.NSEL_DERIVATIVES && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM) || (segId === MARKET_SEGMENT_ID?.MCX_DERIVATIVES && (objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.OPTFUT)))
            delEndDate = 'NA';
        else
            delEndDate = convertToDate(objContractDetails?.nDelEndDate, "DDMMMYYYY").toUpperCase();
    else
        delEndDate = "NA";

    //nearMonthId //farMonthId
    let nearMonthId = 'NA';
    let farMonthId = 'NA';

    if (objContractDetails?.hasOwnProperty("NearMonthSymbol") && objContractDetails?.hasOwnProperty("NearMonthExpiry") &&
        objContractDetails?.hasOwnProperty("FarMonthSymbol") && objContractDetails?.hasOwnProperty("FarMonthExpiry")) {
        if (checkNonBlankNonZero(objContractDetails["NearMonthExpiry"]?.toString())) {
            nearMonthId = objContractDetails["NearMonthSymbol"] + " " + convertToDate(parseFloat(objContractDetails["NearMonthExpiry"]), "DDMMMYYYY").toUpperCase();
        }
        if (checkNonBlankNonZero(objContractDetails["FarMonthExpiry"]?.toString())) {
            farMonthId = objContractDetails["FarMonthSymbol"] + " " + convertToDate(parseFloat(objContractDetails["FarMonthExpiry"]), "DDMMMYYYY").toUpperCase();
        }
    }

    //Margin Info
    let inLongMargin;
    let inShortMargin;
    let appLongMargin;
    let appShortMargin;

    if (objContractMarginDetails?.intialMarginLong || objContractMarginDetails?.intialMarginShort || objContractMarginDetails?.totalMarginLong || objContractMarginDetails?.totalMarginShort) {
        if ((segId === MARKET_SEGMENT_ID?.NSEL_DERIVATIVES && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM) || (segId === MARKET_SEGMENT_ID?.NSEL_SPOT) || (segId === MARKET_SEGMENT_ID?.NMCE_DERIVATIVES) ||
            (segId === MARKET_SEGMENT_ID?.MCX_DERIVATIVES && (objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCBI || objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCSO || objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCTBI || objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCTSI)) ||
            segId === MARKET_SEGMENT_ID?.BSE_DERIVATIVES || segId === MARKET_SEGMENT_ID?.DGCX_DERIVATIVES || segId === MARKET_SEGMENT_ID?.BFX_DERIVATIVES ||
            segId === MARKET_SEGMENT_ID?.UCX_DERIVATIVES || segId === MARKET_SEGMENT_ID?.UCX_SPOT ||
            segId === MARKET_SEGMENT_ID?.DGCX_SPOT || segId === MARKET_SEGMENT_ID?.BFX_SPOT) {
            inLongMargin = 'NA';
            inShortMargin = 'NA';
            appLongMargin = '0';
            appShortMargin = '0';
        }
        else {
            inLongMargin = objContractMarginDetails?.intialMarginLong !== "" ? objContractMarginDetails?.intialMarginLong?.toFixed(2) : 'NA';
            inShortMargin = objContractMarginDetails?.intialMarginShort !== "" ? objContractMarginDetails?.intialMarginShort?.toFixed(2) : 'NA';
            appLongMargin = objContractMarginDetails?.totalMarginLong !== "" ? objContractMarginDetails?.totalMarginLong?.toFixed(2) : 'NA';
            appShortMargin = objContractMarginDetails?.totalMarginShort !== "" ? objContractMarginDetails?.totalMarginShort?.toFixed(2) : 'NA';

            if (objContractMarginDetails?.intialMarginLong === 0) inLongMargin = 0;
            if (objContractMarginDetails?.intialMarginShort === 0) inShortMargin = 0;
            if (objContractMarginDetails?.totalMarginLong === 0) appLongMargin = 0;
            if (objContractMarginDetails?.totalMarginShort === 0) appShortMargin = 0;
        }
    }
    else {
        if ((segId === MARKET_SEGMENT_ID?.NSEL_DERIVATIVES && objContractDetails?.sInstrumentName !== SCRIP_INSTRUMENTS?.FUTCOM) || (segId === MARKET_SEGMENT_ID?.NSEL_SPOT) || (segId === MARKET_SEGMENT_ID?.NMCE_DERIVATIVES) ||
            (segId === MARKET_SEGMENT_ID?.MCX_DERIVATIVES && (objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCBI || objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCSO_TEXT || objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCTBI || objContractDetails?.sInstrumentName === SCRIP_INSTRUMENTS?.AUCTSI)) ||
            segId === MARKET_SEGMENT_ID?.BSE_DERIVATIVES || segId === MARKET_SEGMENT_ID?.DGCX_DERIVATIVES || segId === MARKET_SEGMENT_ID?.BFX_DERIVATIVES ||
            segId === MARKET_SEGMENT_ID?.UCX_DERIVATIVES || segId === MARKET_SEGMENT_ID?.UCX_SPOT ||
            segId === MARKET_SEGMENT_ID?.DGCX_SPOT || segId === MARKET_SEGMENT_ID?.BFX_SPOT ||
            segId === MARKET_SEGMENT_ID?.MSX_FAO) {
            inLongMargin = 'NA';
            inShortMargin = 'NA';
            appLongMargin = '0';
            appShortMargin = '0';

        }
        else {
            inLongMargin = 'NA';
            inShortMargin = 'NA';
            appLongMargin = '0';
            appShortMargin = '0';
        }
    }


    let oLongMargin;
    let oShortMargin;


    if (segId === MARKET_SEGMENT_ID?.MSX_DERIVATIVES) {
        if ((objContractDetails?.nOtherLongMargin))
            oLongMargin = (objContractDetails?.nOtherLongMargin)?.toFixed(2) + " %";;

        if ((objContractDetails?.nOtherLongMargin))
            oShortMargin = (objContractDetails?.nOtherShortMargin)?.toFixed(2) + " %";;
    }

    // //MCX Information ...

    if (segId === MARKET_SEGMENT_ID?.MCX_DERIVATIVES) {
        if (objContractDetails?.nSpecialCashLongMargin)
            oLongMargin = (objContractDetails?.nSpecialCashLongMargin)?.toFixed(2) + " %";

        if (objContractDetails?.nSpecialCashShortMargin)
            oShortMargin = (objContractDetails?.nSpecialCashShortMargin)?.toFixed(2) + " %";
    } else {
        oLongMargin = 'NA';
        oShortMargin = 'NA';

    }
    //Vaibhav Singh : BT-107248: 04-12-23: Added Logic for Handle toggle: start
    const handleShow = (i) => {
        if (showInfo === i) {
            return setShowInfo(null);
        }
        setShowInfo(i);
    };
    //Vaibhav Singh : BT-107248: 04-12-23: Added Logic for Handle toggle: End
    // oLongMargin = objContractDetails?.nSpecialCashLongMargin + '%'
    // oShortMargin = objContractDetails?.nSpecialCashShortMargin + '%'

    const arrCompanyInfo = useMemo(() => [
        {
            id: "register_adress",
            title: "Registered Address",
            tabKey: "register_adress",
            chipContent: <>
                <Container fluid className='g-0'>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Address</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(register)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Telephone</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrTell)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Fax</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrFax)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Email</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrEmail)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3 align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Website</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrWebSite)}</div>
                        </Col>
                    </Row>
                </Container>
            </>
        },
        {
            id: 'head_office',
            title: "Head Office",
            tabKey: 'head_office',
            chipContent:
                <Container fluid className='g-0'>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Address</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(headOfficeAddr)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Telephone</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.hot)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Fax</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.hof)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Email</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.hoe)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3 align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Website</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.how)}</div>
                        </Col>
                    </Row>
                </Container>
        },
        {
            id: "register",
            title: "Registrar",
            tabKey: "register",
            chipContent:
                <Container fluid className='g-0'>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Registrar Name</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrarName)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Address</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(registrar)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Telephone</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrTell)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Fax</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrFax)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Email</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrEmail)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Website</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrWebSite)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3 align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Auditor</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.auditor)}</div>
                        </Col>
                    </Row>
                </Container>
        }
    ], [objCompanyBackgroundData]);

    return (
        <>
            <Container fluid className='p-0 mt-3'>
                <div className='scripoverview-fieldset'>
                    <div className='scripoverview-legend'>COMPANY INFO</div>
                    <div className={`${showMore ? `scripoverview-fieldset-xs` : ``}`}>
                        <div className='so-companyinfo mt-3'>
                            {objCompanyHistory?.length > 0 ?
                                (<div className='font-regular font-size3 lineheight-sm text-justify'>{showMore ? objCompanyHistory?.slice(0, 500) : objCompanyHistory}
                                    <span onClick={toggleReadMore} className='Read-or-hide'>
                                        <a href='#' className='font-medium font-size3 ms-2 chips primary-chip'>{showMore ? "Read More" : "Show Less"}</a>
                                    </span>
                                </div>) : (
                                    <div className='zero-state-alerts zero-state-alerts-md'>
                                        <div className='font-regular font-size2 color-nodata'>No data to display</div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </Container>

            <Container fluid className='p-0 mt-5'>
                <Row className='g-0'>
                    <Col className='pe-3'>
                        <div className='scripoverview-fieldset'>                            
                            <div className='scripoverview-legend'>MANAGEMENT</div>
                            <div className='so-management'>
                                <div className='transparent-card-wrap'>
                                    {arrDirectorData?.length !== 0 && arrDirectorData.map((item, i) => {
                                        return (
                                            <>
                                                <BzCard key={i} className='transparent-card cursor-pointer bdr-btm' onClick={() => { handleShow(i); }}>
                                                    <Row className='g-0'>
                                                        <Col md={11} className='d-flex flex-column justify-content-start align-items-start'>
                                                            <div className='font-medium font-size4 color-text' key={i}>{item.directorName}</div>
                                                            <div className='font-regular font-size2 color-subtext pt-1'>{item.directorDesignation}</div>
                                                        </Col>
                                                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                                                            <div className={`icon-16 ${(showInfo === i) ? 'icon-arrowdown' : 'icon-arrowright'} icon-dark`}>&nbsp;</div>
                                                        </Col>
                                                    </Row>

                                                    {(showInfo === i) ?
                                                        <div className='d-flex flex-column pt-3'>
                                                            <Row className='g-0 py-1 align-items-start'>
                                                                <Col md={4} className='text-start'>
                                                                    <div className='font-regular font-size2 color-subtext'>Year</div>
                                                                </Col>
                                                                <Col md={8} className='text-end'>
                                                                    <div className='font-medium font-size2 color-text'>{item?.year}</div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 py-1 align-items-start'>
                                                                <Col md={4} className='text-start'>
                                                                    <div className='font-regular font-size2 color-subtext'>Qualification</div>
                                                                </Col>
                                                                <Col md={8} className='text-end'>
                                                                    <div className='font-medium font-size2 color-text'>{item?.qualification}</div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 py-1 align-items-start'>
                                                                <Col md={4} className='text-start'>
                                                                    <div className='font-regular font-size2 color-subtext'>Remuneration</div>
                                                                </Col>
                                                                <Col md={8} className='text-end'>
                                                                    <div className='font-medium font-size2 color-text'>{parseFloat(item?.remuneration).toFixed(2)}</div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        : null}
                                                </BzCard>
                                            </>
                                        );
                                    })}
                                </div>
                                {arrDirectorData?.length === 0 &&
                                    <div className='zero-state-alerts zero-state-alerts-xl'>
                                        <div className='font-regular font-size2 color-nodata'>No data to display</div>
                                    </div>
                                }
                            </div>                            
                        </div>
                    </Col>
                    <Col className='ps-3'>
                        <div className='scripoverview-fieldset'>                            
                            <div className='scripoverview-legend'>BASIC DETAILS</div>
                            <div className='basic-details'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Code</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{token ? nullCheck(token) : nullCheck(objContractCodeInfo?.code)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Instrument</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(objContractDetails?.sInstrumentName)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Contract Name</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(objContractDetails?.nContrctName)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Market Lot</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(objContractDetails?.nMarketLot)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Lot Unit</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(objContractDetails?.sLotUnit)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Price Tick (Rs.)</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(nPriceValue)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Maturity</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(nMaturity)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>U/L Asset</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(objContractDetails?.nUlAsset)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>IP Date</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(nIPDate)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Ex.Date</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(nExDate?.toUpperCase())}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Price Quote</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(nPriceQuote)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Margin %</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(margin)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Ex.Multiplier</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(exMultiplierData)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Max Order Size</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(maxOrderSize)}</div>
                                        </Col>
                                    </Row>
                                </Container>     
                            </div>                      
                        </div>
                    </Col>
                </Row>
            </Container>

            <Container fluid className='p-0 mt-5'>
                <Row className='g-0'>
                    <Col className='pe-3'>
                        <div className='scripoverview-fieldset'>
                            <div className='scripoverview-legend'>CONTRACT DATES</div>
                            <Container fluid className='p-0'>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Contrat Start Date</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(ContractStartDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Contract End Date</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(ContractEndDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Tender Start date</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(tenderStartDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Tender End date</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(tenderEndDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Del Start Date</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(delStartDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Del End Date</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(delEndDate)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Near Month Identifier</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(nearMonthId)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Far Month Identifier</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{farMonthId || 'NA'}</div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className='scripoverview-fieldset mt-5'>
                            <div className='scripoverview-legend'>BOOK CLOSURE / RECORD DATA</div>
                            <Container fluid className='p-0'>
                                {recordData &&
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Date</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>NA</div>
                                        </Col>
                                    </Row>
                                }
                                {recordData &&
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Ex.Date</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>NA</div>
                                        </Col>
                                    </Row>
                                }
                                <Row className='g-0 py-3 align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Purpose</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>NA</div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className='scripoverview-fieldset mt-5'>
                            <div className='scripoverview-legend'>CONTACT INFORMATION</div>
                            <div className='submenu-wrapper horizontal-scroll-wrap py-1 mt-3 d-flex justify-content-start'>
                                {arrCompanyInfo?.length && arrCompanyInfo.map((each, i) => (
                                    <BzChip key={i} className={`submenuItem ${each?.id === companyActiveChip ? 'active' : ''}`} onClick={() => {
                                        setCompanyActiveChip(each.id);
                                    }}>
                                        {each.title}
                                    </BzChip>
                                ))}
                            </div>
                            <Container fluid className='p-0 mt-3'>
                                <Row className='g-0'>
                                    <Col>
                                        <BzTabsContainer>
                                            {
                                                arrCompanyInfo?.length && arrCompanyInfo.map((each, i) => (
                                                    <BzTabsContent key={i} tabKey={each.tabKey ? each.tabKey : ''} showDefault={each?.tabKey === companyActiveChip} isActive={each?.tabKey === companyActiveChip}>{each?.chipContent}</BzTabsContent>
                                                ))
                                            }
                                        </BzTabsContainer>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </Col>
                    <Col className='ps-3'>
                        <div className='scripoverview-fieldset'>
                            <div className='scripoverview-legend'>MARGIN INFORMATION</div>
                            <Container fluid className='p-0'>
                                {recordData &&
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Other Long Margin</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(oLongMargin)}</div>
                                        </Col>
                                    </Row>
                                }
                                {recordData &&
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Other Short Margin</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(oShortMargin)}</div>
                                        </Col>
                                    </Row>
                                }
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Intial Long Margin</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(inLongMargin)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Intial Short Margin</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(inShortMargin)}</div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        {recordData &&
                            <div className='scripoverview-fieldset mt-5'>
                                <div className='scripoverview-legend'>FINAL APPLICABLE MARGIN</div>
                                <Container fluid className='p-0'>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Applicable Long Margin</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(appLongMargin)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Applicable Short Margin</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(appShortMargin)}</div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        }
                        <div className='scripoverview-fieldset mt-5'>
                            <div className='scripoverview-legend'>LISTING</div>
                            <Container fluid className='p-0'>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>NSE Symbol</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.nseSymbol)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>BSE Symbol</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.bseSymbol)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>BSE Group</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.bseGroup)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>ISIN</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.isin)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Listed On</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(companyListed)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Sector</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.sector)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 align-items-start'>
                                    <Col className='text-start'>
                                        <div className='font-medium font-size2 color-text'>Part Of Indices</div>
                                        {listing?.length === 0 ?
                                            <div className='font-regular font-size2 color-text'>{nullCheck(null)}</div> :
                                            (
                                                <div className='p-0'>
                                                    {listing[0]?.partOfIndices?.map((item, i) => (
                                                        <span key={i} className='font-regular font-size1 color-text me-1 d-inline-block'>{`${nullCheck(item?.groupname)}${listing[0]?.partOfIndices?.length === i + 1 ? '' : ','}`}</span>
                                                    ))}
                                                </div>
                                            )}
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );

};

export default ContractDetails;
